export default /* @ngInject */ function setRootScopeConfig($rootScope, config) {
    $rootScope.config = config;
}



// WEBPACK FOOTER //
// ./config/set-rootscope-config.js